export const sendgridEn = {
  SENDGRID_CUSTOM_SENDER: 'SendGrid Custom Sender',
  SENDGRID_SEND_FROM_OWN_ADDRESS: 'Send emails from your own address instead of no-reply@factorcloud.com',
  SENDGRID_SENDER_EMAIL: 'Sender Email',
  SENDGRID_SENDER_EMAIL_PLACEHOLDER: 'e.g. notifications@yourdomain.com',
  SENDGRID_CONFIGURE: 'Configure',
  SENDGRID_MANAGE: 'Manage',
  SENDGRID_CURRENT_CONFIG: 'Current configuration',
  SENDGRID_SENDER_EMAIL_SECTION_TITLE: 'Custom sender email',
  SENDGRID_SENDER_EMAIL_SECTION_DESC: 'Override the default "no-reply@factorcloud.com" with an address from your own domain. Leave empty to use the default.',
  SENDGRID_API_KEY_SECTION_TITLE: 'Custom SendGrid API key',
  SENDGRID_API_KEY_SECTION_DESC: 'Optional. Provide your own SendGrid account API key to send through it. Leave empty to use the platform default.',
  SENDGRID_USING_DEFAULT_SENDER: 'Using platform default (no-reply@factorcloud.com)',
  SENDGRID_USING_DEFAULT_API_KEY: 'Using platform default API key',
  SENDGRID_USING_CUSTOM_API_KEY: 'Using custom API key',
  SENDGRID_SAVE: 'Save',
  SENDGRID_RESET_DEFAULT: 'Reset to default',
  SENDGRID_SENDER_UPDATED: 'Sender email updated.',
  SENDGRID_SENDER_CLEARED: 'Sender email reset to default.',
  SENDGRID_API_KEY_UPDATED: 'API key updated.',
  SENDGRID_API_KEY_CLEARED: 'API key reset to default.',
  SENDGRID_VERIFY_SENDER: 'Verify Sender',
  SENDGRID_REMOVE: 'Remove',
  SENDGRID_SEND_TEST: 'Send Test Email',
  SENDGRID_VERIFIED: 'Verified',
  SENDGRID_PENDING_VERIFICATION: 'Pending Verification',
  SENDGRID_NOT_CONFIGURED: 'Not Configured',
  SENDGRID_SENDER_NOT_VERIFIED: 'Sender has not been checked with SendGrid yet (optional — emails are sent regardless).',
  SENDGRID_VERIFY_OPTIONAL_HINT: 'Verification is optional. The sender is used as soon as it is saved. Use Verify to confirm SendGrid recognizes this sender.',
  SENDGRID_SENDER_VERIFIED_MSG: 'Sender is verified. Emails will be sent from your custom address.',
  SENDGRID_CONFIGURE_SUCCESS: 'SendGrid custom sender configured successfully.',
  SENDGRID_REMOVE_SUCCESS: 'SendGrid custom sender configuration removed.',
  SENDGRID_VERIFY_SUCCESS: 'Sender verification successful!',
  SENDGRID_VERIFY_FAILED: 'SendGrid did not recognize this sender. This is informational only — emails will still be sent but may be rejected by SendGrid. Note: only the first 1000 verified senders are checked.',
  SENDGRID_TEST_SUCCESS: 'Test email sent successfully.',
  SENDGRID_ERROR: 'There is a problem with your SendGrid configuration.',
  SENDGRID_SHARED_ACCOUNT: 'Shared Account',
  SENDGRID_TEST_EMAIL_PLACEHOLDER: 'Enter recipient email for test',
  SENDGRID_RETRY: 'Retry Verification',
  SENDGRID_API_KEY: 'SendGrid API Key',
  SENDGRID_API_KEY_PLACEHOLDER: 'SG.xxxxx (leave empty for shared account)',
  SENDGRID_OWN_ACCOUNT: 'Own Account',
  SENDGRID_API_KEY_VALID: 'API key is valid.',
  SENDGRID_API_KEY_INVALID: 'API key is invalid. Please check and try again.',
  SENDGRID_USAGE_TITLE: 'Email Usage (This Month)',
  SENDGRID_USAGE_DELIVERED: 'Delivered',
  SENDGRID_USAGE_BOUNCES: 'Bounces',
  SENDGRID_USAGE_BLOCKS: 'Blocks',
  SENDGRID_USAGE_REQUESTS: 'Requests',
  SENDGRID_CONTACT_SUPPORT: 'To configure or modify SendGrid custom sender settings, please contact FactorCloud support.',
  SENDGRID_NOT_CONFIGURED_TENANT: 'Custom sender email is not configured for your account.',
  SENDGRID_SUPER_ADMIN_ONLY_NOTICE: '⚠️ This section is only visible to super-admins.',
}

export const sendgridEs: typeof sendgridEn = {
  SENDGRID_CUSTOM_SENDER: 'Remitente Personalizado de SendGrid',
  SENDGRID_SEND_FROM_OWN_ADDRESS: 'Envía correos desde tu propia dirección en lugar de no-reply@factorcloud.com',
  SENDGRID_SENDER_EMAIL: 'Email del Remitente',
  SENDGRID_SENDER_EMAIL_PLACEHOLDER: 'ej. notificaciones@tudominio.com',
  SENDGRID_CONFIGURE: 'Configurar',
  SENDGRID_MANAGE: 'Administrar',
  SENDGRID_CURRENT_CONFIG: 'Configuración actual',
  SENDGRID_SENDER_EMAIL_SECTION_TITLE: 'Email de remitente personalizado',
  SENDGRID_SENDER_EMAIL_SECTION_DESC: 'Reemplaza el "no-reply@factorcloud.com" por default con una dirección de tu propio dominio. Dejar vacío para usar el default.',
  SENDGRID_API_KEY_SECTION_TITLE: 'Clave API de SendGrid personalizada',
  SENDGRID_API_KEY_SECTION_DESC: 'Opcional. Proporciona el API key de tu cuenta de SendGrid para enviar a través de ella. Dejar vacío para usar el default de la plataforma.',
  SENDGRID_USING_DEFAULT_SENDER: 'Usando el default de la plataforma (no-reply@factorcloud.com)',
  SENDGRID_USING_DEFAULT_API_KEY: 'Usando el API key default de la plataforma',
  SENDGRID_USING_CUSTOM_API_KEY: 'Usando API key personalizada',
  SENDGRID_SAVE: 'Guardar',
  SENDGRID_RESET_DEFAULT: 'Restaurar default',
  SENDGRID_SENDER_UPDATED: 'Email de remitente actualizado.',
  SENDGRID_SENDER_CLEARED: 'Email de remitente restaurado al default.',
  SENDGRID_API_KEY_UPDATED: 'Clave API actualizada.',
  SENDGRID_API_KEY_CLEARED: 'Clave API restaurada al default.',
  SENDGRID_VERIFY_SENDER: 'Verificar Remitente',
  SENDGRID_REMOVE: 'Eliminar',
  SENDGRID_SEND_TEST: 'Enviar Email de Prueba',
  SENDGRID_VERIFIED: 'Verificado',
  SENDGRID_PENDING_VERIFICATION: 'Verificación Pendiente',
  SENDGRID_NOT_CONFIGURED: 'No Configurado',
  SENDGRID_SENDER_NOT_VERIFIED: 'El remitente aún no ha sido verificado con SendGrid (opcional — los correos se envían igualmente).',
  SENDGRID_VERIFY_OPTIONAL_HINT: 'La verificación es opcional. El remitente se usa apenas se guarda. Usa Verificar para confirmar que SendGrid reconoce este remitente.',
  SENDGRID_SENDER_VERIFIED_MSG: 'Remitente verificado. Los correos se enviarán desde tu dirección personalizada.',
  SENDGRID_CONFIGURE_SUCCESS: 'Remitente personalizado de SendGrid configurado exitosamente.',
  SENDGRID_REMOVE_SUCCESS: 'Configuración de remitente personalizado de SendGrid eliminada.',
  SENDGRID_VERIFY_SUCCESS: '¡Verificación de remitente exitosa!',
  SENDGRID_VERIFY_FAILED: 'SendGrid no reconoció este remitente. Esto es solo informativo — los correos se enviarán igualmente pero pueden ser rechazados por SendGrid. Nota: solo se verifican los primeros 1000 remitentes.',
  SENDGRID_TEST_SUCCESS: 'Email de prueba enviado exitosamente.',
  SENDGRID_ERROR: 'Hay un problema con tu configuración de SendGrid.',
  SENDGRID_SHARED_ACCOUNT: 'Cuenta Compartida',
  SENDGRID_TEST_EMAIL_PLACEHOLDER: 'Ingresa el email del destinatario para la prueba',
  SENDGRID_RETRY: 'Reintentar Verificación',
  SENDGRID_API_KEY: 'Clave API de SendGrid',
  SENDGRID_API_KEY_PLACEHOLDER: 'SG.xxxxx (dejar vacío para cuenta compartida)',
  SENDGRID_OWN_ACCOUNT: 'Cuenta Propia',
  SENDGRID_API_KEY_VALID: 'La clave API es válida.',
  SENDGRID_API_KEY_INVALID: 'La clave API es inválida. Por favor verifica e intenta de nuevo.',
  SENDGRID_USAGE_TITLE: 'Uso de Email (Este Mes)',
  SENDGRID_USAGE_DELIVERED: 'Entregados',
  SENDGRID_USAGE_BOUNCES: 'Rebotes',
  SENDGRID_USAGE_BLOCKS: 'Bloqueados',
  SENDGRID_USAGE_REQUESTS: 'Solicitudes',
  SENDGRID_CONTACT_SUPPORT: 'Para configurar o modificar el remitente personalizado de SendGrid, por favor contacta al soporte de FactorCloud.',
  SENDGRID_NOT_CONFIGURED_TENANT: 'El remitente personalizado de email no está configurado para tu cuenta.',
  SENDGRID_SUPER_ADMIN_ONLY_NOTICE: '⚠️ Esta sección solo es visible para super-admins.',
}
